import React, { createContext, useContext, useState, ReactNode } from 'react';
import OverlayContextType from './OverlayContextType';

const OverlayContext = createContext<OverlayContextType | undefined>(undefined);

export const useOverlay = () => {
  const context = useContext(OverlayContext);
  if (!context) throw new Error('useOverlay must be used within a OverlayProvider');
  return context;
};

export const OverlayProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const showOverlay = () => setIsVisible(true);
  const hideOverlay = () => setIsVisible(false);

  return (
    <OverlayContext.Provider value={{ showOverlay, hideOverlay }}>
      {children}
      {isVisible && <Overlay />}
    </OverlayContext.Provider>
  );
};

const Overlay: React.FC = () => {
  return (
    <div className="fixed inset-0 text-custom-500 bg-black backdrop-blur-md bg-opacity-5 flex justify-center items-center z-[49]">
      <div className="grid-rows-2 justify-center items-center text-center">
        <div className="w-16 h-16 border-8 border-dashed rounded-full animate-spin border-blue-500"></div>
      </div>
    </div>    
  );
};

export default OverlayContext;